<template>
    <div class="filter-bar d-flex flex-wrap align-items-end gap-3 py-2">
        <div class="filter-field" style="min-width: 180px">
            <label class="form-label mb-1">Cerca per nome</label>
            <input type="text" class="form-control" v-model="localValue.name" placeholder="Nome..." />
        </div>

        <div class="filter-field" style="min-width: 180px">
            <label class="form-label mb-1">Descrizione</label>
            <input type="text" class="form-control" v-model="localValue.description" placeholder="Descrizione..." />
        </div>

        <div class="filter-field" style="min-width: 180px">
            <label class="form-label mb-1">Info</label>
            <input type="text" class="form-control" v-model="localValue.info" placeholder="Info..." />
        </div>

        <div class="filter-field" style="min-width: 180px">
            <label class="form-label mb-1">Note</label>
            <input type="text" class="form-control" v-model="localValue.note" placeholder="Note..." />
        </div>

        <div class="filter-field" style="min-width: 180px" v-if="$store.state.isCommessaEditor()">
            <label class="form-label mb-1">Creato da</label>
            <input type="text" class="form-control" v-model="localValue.createdBy" placeholder="Nome utente..." />
        </div>

        <div class="filter-field" style="min-width: 180px" v-if="$store.state.isCommessaEditor()">
            <label class="form-label mb-1">Modificato da</label>
            <input type="text" class="form-control" v-model="localValue.modifiedBy" placeholder="Nome utente..." />
        </div>

        <div class="filter-field" style="min-width: 140px">
            <label class="form-label mb-1">Stato</label>
            <select class="form-control" v-model="localValue.isActive">
                <option :value="null">— Tutti —</option>
                <option :value="true">Attivi</option>
                <option :value="false">Inattivi</option>
            </select>
        </div>

        <div class="filter-field">
            <button class="btn btn-outline-secondary" @click="reset">
                <icon-close /> Reset
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { mixins, Options } from 'vue-class-component';
import * as OM from '@/model';
import WithModel from '@/mixins/withModel';
import store from '@/store';

@Options({})
export default class qrConfigFilters extends mixins(WithModel) {

    declare localValue: OM.QrConfigListFilterVm;

    reset() {
        this.localValue.commessaIdentifier = store.state.commesse.selectedCommessa?.identifier || '';
        this.localValue.name = '';
        this.localValue.description = '';
        this.localValue.info = '';
        this.localValue.note = '';
        this.localValue.createdBy = '';
        this.localValue.modifiedBy = '';
        this.localValue.isActive = null;
    }
}
</script>
